import * as React from 'react'
const EnvelopeOk = (props) => (
  <svg
    width={91}
    height={78}
    viewBox="0 0 91 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#F7F4F1"
      d="M45.485 90C68 90 86.252 71.748 86.252 49.234 86.252 26.719 68 8.467 45.485 8.467 22.971 8.467 4.72 26.72 4.72 49.234 4.719 71.748 22.97 90 45.485 90Z"
    />
    <path
      fill="url(#a)"
      d="M42.856 74.431a2.122 2.122 0 0 1-1.366-3.75l36.38-30.51a2.01 2.01 0 0 0-1.85-1.227H14.54c-1.11 0-2.01.901-2.01 2.01v38.863c0 1.113.9 2.01 2.01 2.01h61.475c1.109 0 2.01-.902 2.01-2.01V45.58L44.213 73.934c-.4.33-.88.497-1.361.497h.004Z"
    />
    <path
      fill="url(#b)"
      d="M77.307 40.624a.788.788 0 0 0 0-1.207l-32.03-26.865-32.03 26.865a.788.788 0 0 0 0 1.207l32.03 26.86 32.03-26.86Z"
    />
    <path fill="#30F" d="M66.72 21.77H23.814v27.716L45.277 67.49 66.72 49.503V21.769Z" />
    <path
      fill="#fff"
      d="M78.029 40.954c0-.277-.057-.542-.159-.783l-36.38 30.51a2.13 2.13 0 0 0-.265 2.992 2.12 2.12 0 0 0 1.63.758c.482 0 .967-.163 1.362-.497L78.03 45.581v-4.627Z"
    />
    <path fill="#E29A0D" d="M48.673 35.047H34.605v16.596h14.068V35.047Z" />
    <path
      fill="#FACA5B"
      d="M59.378 37.122c0-1.146-.93-2.075-2.075-2.075h-9.718a2.076 2.076 0 0 0 0 4.15h-1.313a2.076 2.076 0 0 0 0 4.15h-1.313a2.076 2.076 0 0 0 0 4.15h-1.312a2.076 2.076 0 0 0 0 4.15h9.718a2.076 2.076 0 0 0 0-4.15h1.313a2.076 2.076 0 0 0 0-4.15h1.313a2.076 2.076 0 0 0 0-4.15h1.312c1.146 0 2.075-.93 2.075-2.075Z"
    />
    <path fill="#CFF1CE" d="M38.69 35.047h-7.514v18.145h7.513V35.047Z" />
    <path fill="#3FA73B" d="M38.69 44.117h-7.514v9.07h7.513v-9.07Z" />
    <path
      fill="#E29A0D"
      d="M48.946 24.554 38.694 35.096v5.377l.9.876 9.45-9.718a5.009 5.009 0 0 0-.098-7.082v.005Z"
    />
    <path
      fill="#FACA5B"
      d="M45.277 0a.818.818 0 0 0-.815.815v8.256c0 .448.367.815.815.815a.818.818 0 0 0 .816-.815V.815A.818.818 0 0 0 45.277 0ZM25.579 5.874a.818.818 0 0 0-1.113-.297.818.818 0 0 0-.298 1.113l4.126 7.15a.817.817 0 0 0 1.113.298.814.814 0 0 0 .297-1.113l-4.125-7.15ZM17.49 24.643l-7.15-4.125a.817.817 0 0 0-1.112.297.817.817 0 0 0 .297 1.113l7.147 4.126a.812.812 0 0 0 1.113-.298.817.817 0 0 0-.298-1.113h.004ZM81.331 20.815a.822.822 0 0 0-.493-.379.803.803 0 0 0-.62.082l-7.146 4.125a.816.816 0 0 0 .815 1.41l7.147-4.125a.814.814 0 0 0 .297-1.113ZM66.093 5.577a.817.817 0 0 0-1.113.297l-4.126 7.147a.817.817 0 0 0 .705 1.223c.29 0 .563-.155.706-.408l4.125-7.15a.817.817 0 0 0-.297-1.113v.004Z"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(72.393 0 0 122.051 72.336 18.019)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19AEDF" />
        <stop offset={1} stopColor="#3B6AF4" />
      </radialGradient>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(84.4645 0 0 109.683 66.501 48.142)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.54} stopColor="#19AEDF" />
        <stop offset={1} stopColor="#3B6AF4" />
      </radialGradient>
    </defs>
  </svg>
)
export default EnvelopeOk
